module.exports = __webpack_public_path__ + "static/media/first-workshop@2x.85fc3af8.webp";